export const CONCESSION_CARD_TYPE = {
  HEALTH_CARE: 'HEALTH_CARE',
  PENSIONER: 'PENSIONER',
  COMMONWEALTH_SENIOR: 'COMMONWEALTH_SENIOR',
  VETERAN: 'VETERANS_CARD_HOLDER',
  ATSI: 'ATSI' // Deprecated
} as const;

export type ConcessionCardType = (typeof CONCESSION_CARD_TYPE)[keyof typeof CONCESSION_CARD_TYPE];
